import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "posTermsConditions" */ './POSTermsConditions')),
);

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'POSTermsConditions');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as POSTermsConditions };
